import SelectDinamico from "../../SelectDinamico";

function SelectContato({ campoContato, changeContato, queryContato, disabled = false, empresaLogada, returnOriginal = false, noFilter = false, bindItem, field }) {
    const consulta = queryContato;
    const empresaFilial = empresaLogada || localStorage.getItem("empresaFilial");
    const contatoValue = bindItem ? bindItem[field] : campoContato;

    return (
        <SelectDinamico
            label="Contato"
            cText="U5_CONTAT"
            cValue="U5_CODCONT"
            campoValue={contatoValue}
            consulta={consulta}
            tabela="SU5;AC8"
            isMultiplo={false}
            showNoFilter={noFilter}
            EmpresaLogada={empresaFilial}
            onchange={(e) => {changeContato(e);}}
            returnOrigem={returnOriginal}
            bindItem={bindItem}
            field={field}
            disabled={disabled}
        />
    );
}

export default SelectContato;
